import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 46 46",
  "content": "<symbol viewBox=\"0 0 46 46\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.69746 13.3025L19.3949 23L9.69746 32.6975L12.93 35.93L22.6274 26.2325L32.3249 35.93L35.5574 32.6975L25.8599 23L35.5574 13.3025L32.3249 10.07L22.6274 19.7675L12.93 10.07L9.69746 13.3025Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol